// src/components/_pages/Contact/FormBanner.js
import React from "react";
import "./FormBanner.scss";

const FormBanner = () => {
  return (
    <div id="formBanner-1" className="img-wrap">
      <div id="formbanner-title-1" className="mbd-title">
        <h2 className="formbanner__title fw-700 text-white">
          <span className="t-chunk">The First </span>
          <span className="t-chunk">Step to </span>
          <span className="t-chunk">Your Goal</span>
        </h2>
      </div>
    </div>
  );
};

export default FormBanner;
